var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormatBoldIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M13.025 5a3.675 3.675 0 0 1 2.03 6.74 3.825 3.825 0 0 1-1.68 7.26H6.8V5h6.225zm-.365 8.2H9.83v3h2.83a1.5 1.5 0 0 0 0-3zm-.295-5.43H9.83v2.73h2.535a1.365 1.365 0 1 0 0-2.73z"
}))));
export default SvgFormatBoldIcon;